import React from "react";
import { AppBar, Toolbar, Typography, Container } from "@mui/material";

const Footer = () => {
  return (
    <AppBar
      component="footer"
      sx={{
        position: "fixed",
        bottom: 0,
        width: "100%",
        top: "auto",
        zIndex: 1000,
        boxShadow: "0 -2px 8px rgba(0,0,0,0.1)"
      }}
    >
      <Container maxWidth="lg">
        <Toolbar sx={{ flexDirection: 'column', py: 0.5, minHeight: 'auto' }}>
          <Typography
            variant="caption"
            sx={{
              textAlign: "center",
              fontStyle: 'italic',
              fontSize: '0.7rem',
              lineHeight: 1.3,
            }}
          >
            Humble request to make dua for me and my family, brother Sohail & Abdul and their family — specially at Arafat
          </Typography>
          <Typography variant="caption" sx={{
            color: 'rgba(255,255,255,0.7)',
            fontSize: '0.65rem',
            mt: 0.3,
          }}>
            May Allah accept everyone's Hajj
          </Typography>
        </Toolbar>
      </Container>
    </AppBar>
  );
};

export default Footer;
